import React, { Component } from 'react';
import ChangeProfilePicture from '../../../../_helpers/change-profile-picture';

import { connect } from 'react-redux';
import { Container } from 'react-bootstrap';
import { userActions } from '../../../../_actions/user.actions';
import { userService } from '../../../../_services/user.service';
import { alertActions } from '../../../../_actions/alert.actions';

class EditProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      updatingImage: false,
      updateRequest: false,
      profileUrl: props.currentUser.ProfileUrl,
      firstName: props.currentUser.FirstName,
      lastName: props.currentUser.LastName
    }

    this.handleProfile = this.handleProfile.bind(this)
    this.handleUpdateProfile = this.handleUpdateProfile.bind(this);
  }

  handleUpdateProfile() {
    this.setState({ updateRequest: true })

    userService.updateUser({ firstName: this.state.firstName, lastName: this.state.lastName })
      .then(() => {
        this.setState({ updateRequest: false })

        this.props.dispatch(userActions.setCurrentUser({
          ...this.props.currentUser,
          FirstName: this.state.firstName,
          LastName: this.state.lastName
        }));

        this.props.dispatch(alertActions.success('Profile updated!'));

      })
      .catch((error) => {
        this.props.dispatch(alertActions.error('An error occured and we could not update your profile at this time.'));

        this.setState({ updateRequest: false })
      })
  }

  handleProfile(base64Image) {
    this.setState({ updateRequest: true, updatingImage: true })

    userService.updateUserImage(base64Image)
      .then((data) => {
        this.setState({
          updateRequest: false,
          updatingImage: false,
        })

        this.props.dispatch(userActions.getCurrentUser());
      })
      .catch((error) => {
        this.props.dispatch(alertActions.error('An error occured and we could not update your profile photo at this time.'));

        this.setState({ updateRequest: false, updatingImage: false })
      })
  }

  render() {
    return <Container fluid>
      <div className="row">
        <div className="col-9">
          <div className="card">
            <div className="card-body">
              <h4 className="font-weight-bold mb-3">Edit Your Profile</h4>
              <br />

              <div className="row">
                <div className="col-auto text-center">
                  <ChangeProfilePicture
                    profileUrl={this.props.currentUser.ProfileUrl}
                    uploading={this.state.updatingImage}
                    handleUpload={this.handleProfile}
                    handleError={() =>
                      this.props.dispatch(alertActions.error('We could not read the file image. Please select a jpg/jpeg or png image.'))
                    }
                  />
                  <div>
                    {!this.state.updatingImage &&
                      <a
                        href="/"
                        onClick={e => {
                          e.preventDefault();
                          document.getElementById('ChangeProfileInput').click()
                        }}
                      >Change Picture</a>
                    }
                  </div>
                </div>

                <div className="col">
                  <form>
                    <div className="form-group text-right">
                      <div className="row">
                        <div className="col-3 my-auto">
                          First Name
                        </div>
                        <div className="col-8">
                          <input onChange={e => this.setState({ firstName: e.target.value })} value={this.state.firstName} type="text" className="form-control" />
                        </div>
                      </div>
                    </div>
                    <div className="form-group text-right">
                      <div className="row">
                        <div className="col-3 my-auto">
                          Last Name
                        </div>
                        <div className="col-8">
                          <input onChange={e => this.setState({ lastName: e.target.value })} value={this.state.lastName} type="text" className="form-control" />
                        </div>
                      </div>
                    </div>
                    <div className="form-group text-right">
                      <div className="row">
                        <div className="col-3 my-auto">
                          Username
                        </div>
                        <div className="col-8">
                          <input disabled value={this.props.currentUser.Username} type="text" className="form-control" />
                        </div>
                      </div>
                    </div>
                    <div className="form-group text-right">
                      <div className="row">
                        <div className="col-3 my-auto">
                          Email
                        </div>
                        <div className="col-8">
                          <input disabled value={this.props.currentUser.Email} type="text" className="form-control" />
                        </div>
                      </div>
                    </div>

                    <div className="form-group text-left">
                      <div className="row">
                        <div className="col px-5">
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

            </div>
            <div className="card-footer text-right">
              <button onClick={this.handleUpdateProfile}
                type="submit" disabled={this.state.updateRequest} className="btn btn-primary px-5">{this.state.updateRequest ? 'Updating...' : 'Update Profile'}</button>
            </div>
          </div>
        </div>
      </div>
    </Container >
  }
}

const mapStateToProps = state => {
  return { currentUser: { ...state.user.currentUser } }
}

export default connect(mapStateToProps)(EditProfile)